import { DELETE_BEWERTUNG } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useDeleteBewertung/mutation';
import type { Mitarbeiter_DeleteRotationsplanBewertungMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useDeleteBewertung() {
  const [execute, result] = useMutation(DELETE_BEWERTUNG, {
    refetchQueries: ['mitarbeiter_rotationsplanById'],
    awaitRefetchQueries: true,
  });

  const deleteBewertung = useCallback(
    (variables: Mitarbeiter_DeleteRotationsplanBewertungMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [deleteBewertung, result] as const;
}
